import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarWithCells(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.5 4.5h17M4.75 8.75v-.01m0 4.51v-.01M9 8.75v-.01m0 4.51v-.01m4.25-4.49v-.01M5 8.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m4.25-4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m4.25-4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 8.75h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarWithCells);
export default ForwardRef;
